<template>
  <div class="gantt-main" ref="ganttMain" @scroll="scrolling">
    <div class="top-left-container" ref="top-left-container" :style="topLeftContainerStyling"></div>
    <div class="left-container" :style="{ minWidth: `${leftContainerWidth}px` }" ref="left-container"></div>
    <div class="top-container" :style="{ minWidth: `calc(100% - ${leftContainerWidth}px)` }">
      <div class="top-row" ref="month-row"></div>
      <div class="top-row" ref="date-row"></div>
      <div class="top-row" ref="time-row"></div>
    </div>
    <div class="task-container" :style="taskContainerStyling" ref="task-container">

    </div>

    <div class="to-now-button" :style="toNowButtonStyling" @click="scrollToTime(new Date(), true)">
      <span v-if="toNowButtonStyling['justifyContent'] == 'flex-start'">◁</span>
      <span class="mid-text">Go To Now</span>
      <span v-if="toNowButtonStyling['justifyContent'] == 'flex-end'">▷</span>
    </div>

    <div v-show="showNowMarker" class="now-marker" ref="now-marker">
      <div class="now-marker-text">Now</div>
    </div>

    <div v-show="timeZoomDetails" class="time-col-zoom" ref="time-col-zoom" :style="timeZoomStyling">
      <img @click="timeZoomClose" class="close-btn" src="https://dsmlib.logistics.systems/Icons/Cancel.png" alt="">
      <div class="time-zoom-content">
        <div class="time-container">
          <div class="time-left">{{ timeZoomDetails ? new Date(timeZoomDetails['timeStart']).formatString('yyyy-MM-dd HH:mm') : '' }}</div>
          <div class="time-mid-splitter"></div>
          <div class="time-right">{{ timeZoomDetails ? new Date(timeZoomDetails['timeEnd']).formatString('yyyy-MM-dd HH:mm') : '' }}</div>
        </div>
        <div class="time-zoom-container" v-if="timeZoomDetails">
          <Tooltip class="task-zoom" v-for="(d, i) in timeZoomDetails['data']" :key="i" :style="getTaskZoomStyling(d)" :showIndicator="false" :minWidth="250">
            <div slot="tooltip" class="zoom-tooltip">
              <div style="margin-bottom: 5px">{{ d['cbtext'] }}</div>
              <div>Starts at : {{ d['cbstart'] }}</div>
              <div>Ends at : {{ d['cbend'] }}</div>
            </div>
            <div class="center-text">{{ d['cbtext'] }}</div>
            <div class="zoom-left-text">{{ d['cbltext'] }}</div>
            <div class="zoom-right-text">{{ d['cbrtext'] }}</div>
          </Tooltip>
          <!-- <div class="task-zoom" v-for="(d, i) in timeZoomDetails['data']" :key="i" :style="getTaskZoomStyling(d)">{{ d['cbtext'] }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      start: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ${new Date().getHours() - 1}:${new Date().getMinutes()}`),
      end: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ${new Date().getHours() + 1}:${new Date().getMinutes()}`),
      // start: new Date('2021-10-11 10:05'),
      // end: new Date('2021-10-11 10:30'),

      showNowMarker: true,
      nowMarkerInterval: null,

      totalCol: 0,
      timeWidth: 0,

      mainGantt: null,

      leftContainerWidth: 300,

      topLeftContainerStyling: {
        left: 0,
        top: 0,
        minWidth: 0,
        maxWidth: 0
      },
      taskContainerStyling: {
        top: '60px',
        left: '0px',
        width: '100%'
      },
      toNowButtonStyling: {
        display: 'none',
        left: 0,
        justifyContent: 'flex-start',
      },
      timeZoomStyling: {
        top: 0,
        left: 0,
        height: 0,
        width: 0,
      },
      timeZoomDetails: null,

      resizing: false,
      resizeStartWidth: 0,
      resizeOffset: 0,
      verticalLinePosition: 0,

      dayList: [ 'Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat' ],
      monthList: [ 'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December' ],
    }
  },
  props: {
    interval: { type: Number, default: 30 }, // Interval in minute for each column
    items: { type: Array, default: function() { return [] } }, // The items that goes into the gantt chart (data from API MUST match the data for vehicle schedule page)
    titleMaxWidth: { type: Array, default: function() { return [] } }, // Max width of the left column. Eg: [ '', '150px' ] - No max width for first column and 150px max width for second column
    timeZoneWidth: {type : Number, default : 0},
    // Public events
    // taskClicked - fired when any task is clicked, return the object of the task
    // taskDetailClosed - fired when then task detail popup is closed
    // rowClicked - fired when any row is clicked (left side), return all the task for the row
  },
  methods: {
    generateGantt: function() {
      // Remove vertical line
      Array.from(document.getElementsByClassName('vertical-line')).forEach(l => this.mainGantt.removeChild(l));
      // Remove all task
      Array.from(this.$refs['task-container'].children).forEach(d => this.$refs['task-container'].removeChild(d));
      // Remove all time
      Array.from(this.$refs['time-row'].children).forEach(t => this.$refs['time-row'].removeChild(t));
      // Remove all dates
      Array.from(this.$refs['date-row'].children).forEach(d => this.$refs['date-row'].removeChild(d));
      // Remove all months
      Array.from(this.$refs['month-row'].children).forEach(d => this.$refs['month-row'].removeChild(d));
      // Remove all title
      Array.from(this.$refs['top-left-container'].children).forEach(d => this.$refs['top-left-container'].removeChild(d));
      // Remove all left column
      Array.from(this.$refs['left-container'].children).forEach(d => this.$refs['left-container'].removeChild(d));

      let rowBound = this.$refs['time-row'].getBoundingClientRect();
      let colWidth = ((rowBound.width) / this.totalCol);
      if (colWidth < 35) {
        colWidth = 35;
      }
      this.timeWidth = colWidth;
      
      let time = new Date(this.start);
      let date = time.getDate();
      let dayChange = [];
      let month = time.getMonth();
      let monthChange = [];
      
      for (let i = 0; i < this.totalCol; i++) {
        this.$refs['time-row'].appendChild(this.createDiv(`${time.formatString('HHmm')}`, ['row-content'], {
          minWidth: i == this.totalCol - 1 ? `${colWidth}px` : i == 0 ? `${colWidth + 1}px` : `${colWidth}px`,
          maxWidth: i == this.totalCol - 1 ? `${colWidth}px` : i == 0 ? `${colWidth + 1}px` : `${colWidth}px`,
          borderRight: i == this.totalCol - 1 ? 'none' : '',
          color: 'gray'
        }));

        if (i < this.totalCol - 1) {
          this.mainGantt.appendChild(this.createDiv(null, ['vertical-line'], {
            left: `${colWidth * (i + 1) + this.leftContainerWidth}px`
          }));
        }
        
        time = new Date(time.getTime() + (this.interval * 60 * 1000));
        if (time.getDate() != date) {
          dayChange.push({ index: i, date: new Date(time.getTime() - 60000) });
        }
        if (time.getMonth() != month) {
          monthChange.push({ index: i, date: new Date(time.getTime() - 60000) });
        }
        date = time.getDate();
        month = time.getMonth();
      }

      if (dayChange.length == 0) {
        dayChange.push({ index: this.totalCol - 1, date: new Date(time.getTime() - 60000) });
      } else if (dayChange[dayChange.length - 1]['index'] != this.totalCol - 1) {
        dayChange.push({ index: this.totalCol - 1, date: new Date(time.getTime() - 60000) });
      }

      if (monthChange.length == 0) {
        monthChange.push({ index: this.totalCol - 1, date: new Date(time.getTime() - 60000) });
      } else if (monthChange[monthChange.length - 1]['index'] != this.totalCol - 1) {
        monthChange.push({ index: this.totalCol - 1, date: new Date(time.getTime() - 60000) });
      }

      dayChange.forEach((d, i) => {
        let width = 0;
        if (i == 0) {
          width = colWidth * (d['index'] + 1) + 1;
        } else {
          let length = (d['index'] - 1) - dayChange[i - 1]['index'];
          width = colWidth * (length + 1);
        }

        let text = `${d['date'].getDate()}, ${this.dayList[d['date'].getDay()]}`;
        let classes = [ 'row-content' ];
        if (`${d['date'].getFullYear()}-${d['date'].getMonth() + 1}-${d['date'].getDate()}` == `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`) {
          classes.push('today-row-date');
        }
        this.$refs['date-row'].appendChild(this.createDiv(text, classes, {
          width: `${width}px`,
          borderRight: i == dayChange.length - 1 ? 'none' : ''
        }));
      });

      monthChange.forEach((m, i) => {
        let width = 0;
        if (i == 0) {
          width = colWidth * (m['index'] + 1) + 1;
        } else {
          let length = (m['index'] - 1) - monthChange[i - 1]['index'];
          width = colWidth * (length + 1);
        }

        let text = `${this.monthList[m['date'].getMonth()]}, ${m['date'].getFullYear()}`;
        this.$refs['month-row'].appendChild(this.createDiv(text, [ 'row-content' ], {
          width: `${width}px`,
          borderRight: i == monthChange.length - 1 ? 'none' : ''
        }));
      });

      this.taskContainerStyling['left'] = `${this.leftContainerWidth}px`;
      this.taskContainerStyling['width'] = `${this.$refs['time-row'].getBoundingClientRect().width}px`;

      // Add resizer
      let resizer = this.createDiv(null, ['left-resizer'], null);
      resizer.addEventListener('mousedown', (e) => {
        let resizeStartLeft = e.target.getBoundingClientRect().left;
        this.resizeStartWidth = this.leftContainerWidth;
        this.resizeOffset = e.pageX - resizeStartLeft;
        this.resizing = true
      });
      this.$refs['left-container'].appendChild(resizer);
      // Add resizer

      if (this.items.length > 0) {
        this.populateItems();
      }
      
      if (this.nowMarkerInterval) {
        window.clearInterval(this.nowMarkerInterval);
      }

      this.placeNowMarker();
      if (this.showNowMarker) {
        let now = new Date();
        let delay = 60000 - ((now.getSeconds() * 1000) + now.getMilliseconds());
        setTimeout(() => {
          this.placeNowMarker();
          this.nowMarkerInterval = setInterval(this.placeNowMarker, 60000);
        }, delay);
      }
    },
    populateItems: function() {
      let allpid = [...new Set(this.items.map(i => i['pid']))];

      let colTitles = [];
      if (this.items[0]['col1title']) { colTitles.push('col1') }
      if (this.items[0]['col2title']) { colTitles.push('col2') }
      if (this.items[0]['col3title']) { colTitles.push('col3') }
      
      // Left title
      colTitles.forEach((c, i) => {
        let style = null;
        let maxWidth = this.titleMaxWidth[i];
        if (maxWidth) {
          style = { maxWidth: maxWidth };
        }
        this.$refs['top-left-container'].appendChild(this.createDiv(this.items[0][`${c}title`], ['left-column-text'], style));
      });

      let rowIndex = 0;

      allpid.forEach(p => {
        let parentTimeLine = this.items.filter(i => i['pid'] == p).map(pi => {
          let start = new Date(pi['cbstart']).getTime();
          return { start: new Date(start), end: new Date(start + (pi['cbduration'] * 60 * 60 * 1000)) };
        });
        let pstart = Math.min.apply(null, parentTimeLine.map(t => t['start']));
        let pend = Math.max.apply(null, parentTimeLine.map(t => t['end']));

        let allChild = this.items.filter(i => i['pid'] == p);
        let uniqueChild = [...new Set(allChild.map(ac => ac['cid']))];

        // Left side column (Parent)
        let leftColumn = this.items.find(i => i['pid'] == p);
        let taskLeftColumns = this.createDiv(null, ['task-row'], null);

        // For close child button
        // let closeImg = this.createImg('https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png', null, {
        //   height: '15px',
        //   width: '15px',
        //   cursor: 'pointer',
        //   marginLeft: '5px'
        // });
        // closeImg.setAttribute('indexes', JSON.stringify({ show: true, startIndex: this.$refs['left-container'].children.length, endIndex: this.$refs['left-container'].children.length + uniqueChild.length }));
        // closeImg.addEventListener('click', (e) => {
        //   let img = e.target;
        //   let indexes = JSON.parse(img.getAttribute('indexes'));
        //   let src = img.getAttribute('src');

        //   let allLeftChild = Array.from(this.$refs['left-container'].children).slice(indexes['startIndex'] + 1, indexes['endIndex'] + 1);
        //   let allTaskRow = Array.from(this.$refs['task-container'].children).slice(indexes['startIndex'], indexes['endIndex']);

        //   if (src == 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png') { // To Open
        //     img.setAttribute('src', 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png');
        //     allLeftChild.forEach(l => l.style.display = 'flex');
        //     allTaskRow.forEach(l => l.style.display = 'flex');
        //   } else { // To Close
        //     img.setAttribute('src', 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png');
        //     allLeftChild.forEach(l => l.style.display = 'none');
        //     allTaskRow.forEach(l => l.style.display = 'none');
        //   }

        //   this.changeVerticalLineHeight();
        // });
        // taskLeftColumns.appendChild(closeImg);
        // For close child button

        this.$refs['left-container'].appendChild(this.createLeftColumnText(colTitles, false, pstart, [leftColumn]));
        // Left side column (Parent)
        
        // for parent task
        let taskRow = this.createDiv(null, ['task-row'], null);
        taskRow.appendChild(this.createTask(new Date(pstart), new Date(pend)));
        this.$refs['task-container'].appendChild(taskRow);
        // for parent task
        
        uniqueChild.forEach(u => {
          let childTask = allChild.filter(ac => ac['cid'] == u);
          let childTimeLine = childTask.map(ci => {
            let start = new Date(ci['cbstart']).getTime();
            return { start: new Date(start), end: new Date(start + (ci['cbduration'] * 60 * 60 * 1000)) };
          });
          let cstart = Math.min.apply(null, childTimeLine.map(t => t['start']));

          // assign lanes
          const LANE_H = 25;
          const sorted = [...childTask].sort((a, b) =>
            new Date(a['cbstart']) - new Date(b['cbstart'])
          );
          const lanes = [];
          sorted.forEach(ct => {
            const s = new Date(ct['cbstart']).getTime();
            const e = s + (ct['cbduration'] * 60 * 60 * 1000);
            let placed = false;
            for (let li = 0; li < lanes.length; li++) {
              if (lanes[li] <= s) { ct._lane = li; lanes[li] = e; placed = true; break; }
            }
            if (!placed) { ct._lane = lanes.length; lanes.push(e); }
          });
          const numLanes = lanes.length;
          const rowH = numLanes * LANE_H;

          const rowBg       = rowIndex % 2 === 0 ? 'rgba(226, 228, 255, 0.5)' : 'transparent';
          rowIndex++; 

          // left column
          const leftCol = this.createLeftColumnText(colTitles, true, cstart, childTask);
          leftCol.style.height = rowH + 'px';
          leftCol.style.backgroundColor = rowBg;
          this.$refs['left-container'].appendChild(leftCol);

          // task row
          const childTaskRow = this.createDiv(null, ['task-row'], null);
          childTaskRow.style.height = rowH + 'px';
          childTaskRow.style.backgroundColor = rowBg;
          childTaskRow.setAttribute('child', u);
          childTaskRow.setAttribute('parent', p);
          childTask.forEach(ct => {
            const ctStart = new Date(ct['cbstart']).getTime();
            const ctEnd = ctStart + (ct['cbduration'] * 60 * 60 * 1000);
            const taskEl = this.createTask(ctStart, ctEnd, ct);
            taskEl.style.top = (ct._lane * LANE_H + 2) + 'px';
            childTaskRow.appendChild(taskEl);
          });
          this.$refs['task-container'].appendChild(childTaskRow);
        });
      });

      this.changeVerticalLineHeight();

      this.$nextTick(() => {
        if (this.showNowMarker) { // Auto scroll the gantt chart to show the now marker in the middle
          this.scrollToTime(new Date(), true);
        }

        this.$refs['task-container'].addEventListener('click', this.ganttClicked);
      });
    },
    scrollToTime: function(date, center) {
      let scrollableGantt = this.$refs['ganttMain'];

      let scroll = ((date - this.start) / 1000 / 60 / this.interval) * this.timeWidth;

      let ganttWidth = (scrollableGantt.getBoundingClientRect().width - this.leftContainerWidth);
      if (center) {
        ganttWidth /= 2;
        scroll -= ganttWidth;
      } else {
        scroll -= 25;
      }

      scrollableGantt.scrollTo({ behavior: 'smooth', left: scroll, top: scrollableGantt.scrollTop });
    },
    scrolling: function(e) {
      if (this.showNowMarker) {
        let markerLeft = this.$refs['now-marker'].getBoundingClientRect().left;

        let targetBounding = e.target.getBoundingClientRect();
        let targetWidth = targetBounding.width;
        let targetLeft = targetBounding.left;

        let leftBound = targetLeft + this.leftContainerWidth;
        let rightBound = targetWidth + targetLeft;
        
        if (markerLeft < rightBound && markerLeft > leftBound) {
          this.toNowButtonStyling['display'] = 'none';
        } else if (markerLeft < leftBound) {
          this.toNowButtonStyling['display'] = 'flex';
          this.toNowButtonStyling['left'] = `${leftBound + 3}px`;
          this.toNowButtonStyling['justifyContent'] = 'flex-start';
        } else if (markerLeft > rightBound) {
          this.toNowButtonStyling['display'] = 'flex';
          this.toNowButtonStyling['left'] = `${rightBound - 103}px`;
          this.toNowButtonStyling['justifyContent'] = 'flex-end';
        }
      }
    },
    placeNowMarker: function() {
      let nowTime = new Date().getTime();
      if (nowTime <= this.end && nowTime >= this.start) {
        let minDiff = Math.floor((nowTime - this.start) / 1000 / 60);
        if (this.$refs['now-marker']) {
          this.$refs['now-marker'].style.left = `${((minDiff / this.interval) * this.timeWidth) + this.leftContainerWidth}px`;
        }
      } else {
        if (this.nowMarkerInterval) {
          window.clearInterval(this.nowMarkerInterval);
        }
        this.showNowMarker = false;
      }
    },
    createTask: function(start, end, taskItem) {
      let width = ((end - start) / 1000 / 60) / this.interval * this.timeWidth;
      let startPos = ((start - this.start) / 1000 / 60) / this.interval * this.timeWidth;

      let taskText = '';
      let taskColor = '';
      let taskLeftText = '';
      let taskRightText = '';
      if (taskItem) {
        taskText = taskItem['cbtext'] || '';
        taskColor = parseFloat(taskItem['cbprogress']) >= 1 ? (taskItem['cbprogresscolor'] || '') : (taskItem['cbcolor'] || '');
        taskLeftText = taskItem['cbltext'] || '';
        taskRightText = taskItem['cbrtext'] || '';
      }

      // this was the missing block
      let taskDiv = this.createDiv(null, ['gantt-task-block'], {
        left: `${startPos}px`,
        width: `${width + 1}px`,
        backgroundColor: taskColor,
        cursor: taskItem ? 'pointer' : 'default'
      });

      if (taskItem) {
        taskDiv.appendChild(this.createDiv(taskLeftText, ['task-left-text'], {
          fontSize: `${taskItem['cblfontsize']}px`
        }));

        taskDiv.appendChild(this.createDiv(taskRightText, ['task-right-text'], {
          fontSize: `${taskItem['cbrfontsize']}px`
        }));

        taskDiv.appendChild(this.createDiv(null, ['task-progress'], {
          width: `${taskItem['cbprogress'] * 100}%`,
          backgroundColor: taskItem['cbprogresscolor']
        }));

        let textDiv = this.createDiv(taskText, ['task-inner-text'], {
          color: taskItem['cbtextcolor']
        });
        taskDiv.appendChild(textDiv);

        taskDiv.addEventListener('mouseenter', (e) => {
          const tt = this._tooltip;
          tt.innerHTML = `
            <div class="tt-title">${taskItem['cbtext'] || ''}</div>
            <div class="tt-row"><span>Starts at: </span><span>${new Date(taskItem['cbstart']).formatString('yyyy-MM-dd HH:mm')}</span></div>
            <div class="tt-row"><span>Ends at: </span><span>${new Date(new Date(taskItem['cbstart']).getTime() + taskItem['cbduration'] * 3600000).formatString('yyyy-MM-dd HH:mm')}</span></div>
            ${taskItem['cbltext'] ? `<div class="tt-row"><span>From: </span><span>${taskItem['cbltext'].split(' ')[1]}</span></div>` : ''}
            ${taskItem['cbrtext'] ? `<div class="tt-row"><span>To: </span><span>${taskItem['cbrtext']}</span></div>` : ''}
            <div class="tt-row"><span>Action : ${taskItem['cbltext'].split(' ')[0]}</span></div>
          `;
          tt.style.display = 'block';
          tt.style.left = (e.clientX + 12) + 'px';
          tt.style.top  = (e.clientY - 10) + 'px';
        });
        taskDiv.addEventListener('mousemove', (e) => {
          this._tooltip.style.left = (e.clientX + 12) + 'px';
          this._tooltip.style.top  = (e.clientY - 10) + 'px';
        });
        taskDiv.addEventListener('mouseleave', () => {
          this._tooltip.style.display = 'none';
        });
        textDiv.addEventListener('click', () => {
          this.$emit('taskClicked', taskItem);
        });
      }

      return taskDiv;
    },
    createDiv: function(content, classList, style) {
      let div = document.createElement('div');
      
      if (classList) {
        classList.forEach(c => div.classList.add(c));
      }

      if (style) {
        Object.keys(style).forEach(s => div.style[s] = style[s]);
      }

      if (content) {
        div.innerHTML = content;
        div.title = content;
      }

      return div;
    },
    createImg: function(src, classList, style) {
      let img = document.createElement('img');
      
      if (classList) {
        classList.forEach(c => img.classList.add(c));
      }

      if (style) {
        Object.keys(style).forEach(s => img.style[s] = style[s]);
      }

      if (src) {
        img.src = src;
      }

      return img;
    },

    createLeftColumnText: function(titles, isChild, rowStart, task) {
      let leftColText = this.createDiv(null, ['task-row'], null);
      titles.forEach((c, i) => {
        let style = {
          cursor: 'pointer',
          paddingLeft: isChild ? (i == 0 ? '15px' : '5px') : ''
        };
        let maxWidth = this.titleMaxWidth[i];
        if (maxWidth) {
          style['maxWidth'] = maxWidth;
        }

        let colItem = null;
        if (isChild) {
          colItem = this.createDiv(task[0][`c${c}text`], ['left-column-text'], style);
        }
        else {
          colItem = this.createDiv(task[0][`p${c}text`], ['left-column-text'], style);
        }

        colItem.addEventListener('click', () => {
          this.scrollToTime(new Date(rowStart));
          if (isChild) {
            this.$emit('rowClicked', task);
          }
        });
        colItem.addEventListener('mouseover', (e) => {
          let parent = e.target.parentNode;
          parent.classList.add('task-row-hover');

          let hoverIndex = Array.from(this.$refs['left-container'].children).indexOf(parent);
          let taskRowItem = Array.from(this.$refs['task-container'].children)[hoverIndex - 1];
          taskRowItem.classList.add('task-row-hover');
        });
        colItem.addEventListener('mouseout', (e) => {
          let parent = e.target.parentNode;
          parent.classList.remove('task-row-hover');
          
          let hoverIndex = Array.from(this.$refs['left-container'].children).indexOf(parent);
          let taskRowItem = Array.from(this.$refs['task-container'].children)[hoverIndex - 1];
          taskRowItem.classList.remove('task-row-hover');
        });

        leftColText.appendChild(colItem);
      });
      return leftColText;
    },

    pageResize: function(e) {
      this.mainGantt = this.$refs['ganttMain'];
      this.$refs['task-container'].removeEventListener('click', this.ganttClicked);
      
      let ganttMain = this.mainGantt.getBoundingClientRect();
      this.topLeftContainerStyling['left'] = `${ganttMain.left + 1}px`;
      this.topLeftContainerStyling['top'] = `${ganttMain.top + 1}px`;
      this.topLeftContainerStyling['maxWidth'] = `${this.leftContainerWidth}px`;
      this.topLeftContainerStyling['minWidth'] = `${this.leftContainerWidth}px`;

      this.timeZoomStyling['left'] = `${ganttMain.left}px`;
      this.timeZoomStyling['top'] = `${ganttMain.top}px`;
      this.timeZoomStyling['width'] = `${ganttMain.width}px`;
      this.timeZoomStyling['height'] = `${ganttMain.height}px`;

      // create shared tooltip if it doesn't exist yet
      if (!this._tooltip) {
        this._tooltip = document.createElement('div');
        this._tooltip.className = 'gantt-hover-tooltip';
        document.body.appendChild(this._tooltip);
      }
      
      this.generateGantt();
    },

    changeVerticalLineHeight: function() {
      let containerHeight = this.$refs['task-container'].getBoundingClientRect().height;
      
      // make sure all vertical lines reached to the bottom of the container
      this.$refs['left-container'].style.height = `${containerHeight + 60}px`;
      Array.from(document.getElementsByClassName('vertical-line')).forEach(v => v.style.height = `${containerHeight + 60}px`);
      // make sure all vertical lines reached to the bottom of the container

      // Make sure now marker height reached to the bottom of the container
      this.$refs['now-marker'].style.height = `${containerHeight + 60}px`;
      // Make sure now marker height reached to the bottom of the container

      // Testing for on gantt clicked
      // this.$refs['task-container'].appendChild(this.createDiv(null, ['dot'], null));
      // Testing for on gantt clicked
    },

    ganttClicked: function(e) {
      let gantt = this.$refs['ganttMain'];
      let ganttBounds = gantt.getBoundingClientRect();
      let ganttLeft = ganttBounds.left;
      let ganttTop = ganttBounds.top;
      let scrollTop = gantt.scrollTop;
      let scrollLeft = gantt.scrollLeft;

      let timeCoordinate = e['clientX'] - ganttLeft + scrollLeft - this.leftContainerWidth;
      let rowCoordinate = e['clientY'] - ganttTop + scrollTop - 60;
      
      let overlapped = this.getOverlappedItems(timeCoordinate, rowCoordinate);
      if (overlapped) {
        if (overlapped['data'].length > 0) {
          console.log(overlapped);
          this.timeZoomDetails = overlapped;
        }
      }
    },
    getTimeRangeFromCoordinate: function(coord) {
      let timeCol = coord / this.timeWidth;
      let totalStartTimeInMillis = Math.floor(timeCol) * this.interval * 60 * 1000;
      let totalTimeInMillis = timeCol * this.interval * 60 * 1000;

      let rangeStart = this.start + totalStartTimeInMillis;

      return { time: this.start + totalTimeInMillis, start: rangeStart, end: rangeStart + (this.interval * 60 * 1000) };
    },
    getRowDetailsFromCoordinate: function(coord) {
      let rows = Array.from(this.$refs['task-container'].children);
      let cumulative = 0;
      let rowElement = null;
      for (let r of rows) {
        cumulative += r.getBoundingClientRect().height;
        if (coord < cumulative) { rowElement = r; break; }
      }
      if (!rowElement) return null;

      let parent = rowElement.getAttribute('parent');
      let child = rowElement.getAttribute('child');
      if (parent && child) {
        return this.items.filter(i => i['pid'] == parent).filter(p => p['cid'] == child);
      } else {
        return null;
      }
    },
    getOverlappedItems: function(timeCoord, rowCoord) {
      let timeRange = this.getTimeRangeFromCoordinate(timeCoord);
      let details = this.getRowDetailsFromCoordinate(rowCoord);

      if (!details) {
        return null;
      } else {
        let times = details.map(d => {
          let start = new Date(d['cbstart']).getTime();
          return { start: start, end: start + (d['cbduration'] * 60 * 60 * 1000), data: d };
        });
        let overlapped = times.filter(t => {
          if (t['start'] == timeRange['end']) { return false }
          if (t['end'] == timeRange['start']) { return false }
 
          let startWithin = t['start'] >= timeRange['start'] && t['start'] <= timeRange['end'];
          let endWithin = t['end'] >= timeRange['start'] && t['end'] <= timeRange['end'];
          let timeStartWithin = timeRange['start'] <= t['end'] && timeRange['start'] >= t['start'];
          let timeEndWithin = timeRange['end'] <= t['end'] && timeRange['end'] >= t['start'];
          return startWithin || endWithin || timeStartWithin || timeEndWithin;
        });

        return {
          timeStart: timeRange['start'],
          timeEnd: timeRange['end'],
          data: overlapped.map(o => {
            let data = o['data'];
            data['cbend'] = new Date(o['end']).formatString('yyyy-MM-dd HH:mm');
            return data;
          })
        };
      }
    },
    getTaskZoomStyling: function(data) {
      let startTime = this.timeZoomDetails['timeStart'];
      let endTime = this.timeZoomDetails['timeEnd'];
      let dataStart = new Date(data['cbstart']);
      let dataEnd = new Date(dataStart.getTime() + (data['cbduration'] * 60 * 60 * 1000));

      let styling = {
        left: 0,
        width: '100%',
        // if progress is greater than or equal to 100%, use progresscolor instead
        backgroundColor: parseFloat(data['cbprogress']) >= 1 ? data['cbprogresscolor'] : data['cbcolor'],
        color: data['cbtextcolor']
      };

      if (dataStart >= startTime && dataEnd <= endTime) {
        let left = `${(((dataStart - startTime) / 1000 / 60) / this.interval) * 100}%`;
        let diffInMinutes = (dataEnd - dataStart) / 1000 / 60;
        styling['left'] = left;
        styling['width'] = `${diffInMinutes / this.interval}%`;
        styling['borderWidth'] = '1px';
      } else if (dataStart >= startTime) {
        let left = `${(((dataStart - startTime) / 1000 / 60) / this.interval) * 100}%`;
        styling['left'] = left;
        styling['width'] = `calc(100% - ${left})`;
        styling['borderWidth'] = '1px 0 1px 1px';
      } else if (dataEnd <= endTime) {
        styling['width'] = `${(((dataEnd - startTime) / 1000 / 60) / this.interval) * 100}%`;
        styling['borderWidth'] = '1px 1px 1px 0';
      } else {
        styling['borderWidth'] = '1px 0 1px 0';
      }

      return styling;
    },

    timeZoomClose: function() {
      this.timeZoomDetails = null
      this.$emit('taskDetailClosed');
    },

    init: function() {
      if (this.items.length > 0) {
        this.items.forEach(i => {
          const pm = (i.pcol1text || '').trim();   // Prime Mover column
          const driver = (i.pcol2text || '').trim(); // Driver column

          // Create a deterministic unique parent id
          i.pid = `${pm}||${driver}`;
        });

        // ensure cid is unique per container
        this.items.forEach(i => {
          if (!i.cid) {
            i.cid = `${i.pid}||${i.jobno || ''}||${i.seqno || ''}`;
          }
        });

        this.items.forEach(i => {
          if (i['cbduration'] < 0) { i['cbduration'] = 0 }
        });

        let itemTimeLine = this.items.map(i => {
          let start = new Date(i['cbstart']).getTime();
          return { start: new Date(start), end: new Date(start + (i['cbduration'] * 60 * 60 * 1000)) };
        });
        let minStart = Math.min.apply(null, itemTimeLine.map(t => t['start']));
        let maxEnd = Math.max.apply(null, itemTimeLine.map(t => t['end']));
        this.start = new Date(minStart);
        this.end = new Date(maxEnd);
      }

      this.showNowMarker = true;

      let startDiff = this.start.getMinutes() % this.interval;
      this.start = this.start.setMinutes(this.start.getMinutes() - startDiff);

      let endDiff = this.end.getMinutes() % this.interval;
      this.end = this.end.setMinutes(this.end.getMinutes() + (this.interval - endDiff));

      this.totalCol = Math.ceil((this.end - this.start) / 1000 / 60 / this.interval); // in minutes

      this.$nextTick(() => this.pageResize());
    }
  },
  mounted() {
    this.init();

    window.addEventListener('resize', this.pageResize);
    window.addEventListener('mouseup', () => {
      if (this.resizing) {
        Array.from(document.getElementsByClassName('vertical-line')).forEach((v, i) => {
          let newPos = this.leftContainerWidth + ((i + 1) * this.timeWidth);
          v.style.left = `${newPos}px`;
        });

        if (this.showNowMarker) {
          this.placeNowMarker();
        }
        
        this.resizing = false;
      }
    });
    window.addEventListener('mousemove', (e) => {
      if (this.resizing) {
        let leftContainerBounds = this.$refs['left-container'].getBoundingClientRect();
        let resizer = document.getElementsByClassName('left-resizer')[0];
        
        let size = e.pageX - leftContainerBounds.left - this.resizeOffset;
        resizer.style.left = `${e.pageX - leftContainerBounds.left - this.resizeOffset}px`;
        
        this.taskContainerStyling['left'] = `${size + 3}px`;
        this.topLeftContainerStyling['minWidth'] = `${size + 3}px`;
        this.topLeftContainerStyling['maxWidth'] = `${size + 3}px`;

        this.leftContainerWidth = size + 3;

        this.verticalLinePosition = this.leftContainerWidth - this.resizeStartWidth;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.pageResize);

    if (this._tooltip) {
      document.body.removeChild(this._tooltip);
      this._tooltip = null;
    }
  },
  watch: {
    items: function(val) {
      if (val.length == 0) {
        this.start = new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ${new Date().getHours() - 1}:${new Date().getMinutes()}`);
        this.end = new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ${new Date().getHours() + 1}:${new Date().getMinutes()}`);
      }
      this.init();
    },

    timeZoneWidth : function (val) {
      this.timeZoomStyling['width'] = `${val}px`;
      this.toNowButtonStyling['left'] = `${val - 50}px`;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
$ganttColor: rgba(128,128,128,0.3);

* {
  box-sizing: border-box;
}

.gantt-main {
  height: 100%;
  width: 100%;
  border: 1px solid $ganttColor;
  display: flex;
  position: relative;
  overflow: auto;

  > .left-container, > .top-container {
    position: sticky;
  }

  > .main-container {
    // background-color: red;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    padding-left: 200px;
    padding-top: 60px;

    > .inner {
      width: 50px;
      height: 1000px;
      background-color: green;
    }

    > .inner2 {
      width: 1500px;
      height: 50px;
      background-color: green;
    }
  }

  > .left-container {
    left: 0;
    background-color: white;
    min-width: 200px;
    height: 100%;
    border-right: 1px solid $ganttColor;
    z-index: 2;
    padding-top: 60px;
  }

  > .top-container {
    background-color: white;
    height: 60px;
    top: 0;
    z-index: 3;
    font-size: 10px;
    // min-width: calc(100% - 200px);

    > .top-row {
      height: 20px;
      border-bottom: 1px solid $ganttColor;
      display: flex;
      align-items: center;
      min-width: 100%;
      width: fit-content;
      background-color: white;
    }
  }

  > .top-left-container {
    z-index: 5;
    height: 60px;
    // min-width: 199px;
    background-color: white;
    position: fixed;
    left: 0;
    top: 0;
    border-bottom: 1px solid $ganttColor;
    border-right: 1px solid $ganttColor;
    display: flex;
  }

  > .task-container {
    position: absolute;
    top: 60px;
    z-index: 1;
  }

  > .to-now-button {
    position: fixed;
    z-index: 5;
    font-size: 10px;
    height: 20px;
    display: flex;
    align-items: center;
    width: 100px;
    padding: 0 5px;

    > .mid-text {
      text-decoration: underline;
      cursor: pointer;
    }

    > span {
      margin: 0 3px;
    }
  }

  > .time-col-zoom {
    position: fixed;
    z-index: 99;
    background-color: rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    justify-content: center;

    > .close-btn {
      position: absolute;
      right: 5px;
      top: 5px;
      height: 50px;
      width: 50px;
      cursor: pointer;
    }

    > .time-zoom-content {
      width: 90%;
      height: 90%;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      overflow-y: auto;

      > .time-container {
        width: 80%;
        display: flex;

        > .time-left {
          position: relative;
          transform: translateX(-50%);
        }

        > .time-mid-splitter {
          flex-grow: 1;
        }

        > .time-right {
          position: relative;
          transform: translateX(50%);
          text-align: right;
        }
      }

      > .time-zoom-container {
        //border: 1px solid black;
        width: 80%;
        height: 80%;
        position: relative;

        > .task-zoom {
          width: 100%;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          margin: 5px 0;
          position: relative;
          border-style: solid;
          border-color: black;
          white-space: nowrap;
          min-width: 10px;

          > .center-text {
            pointer-events: none;
            width: 100%;
            overflow: hidden;
          }

          > .zoom-left-text, > .zoom-right-text {
            position: absolute;
            white-space: nowrap;
            margin: 0 3px;
            pointer-events: none;
          }

          > .zoom-right-text {
            left: 100%;
            top: 0;
          }

          > .zoom-left-text {
            right: 100%;
            bottom: 0;
            text-align: right;
          }
        }
      }
    }
  }
}

.zoom-tooltip {
  text-align: left;
  padding: 10px;
  width: max-content;
  white-space: nowrap;
}

.now-marker {
  height: 100%;
  width: 2px;
  background-color: rgba(255,0,0,0.5);
  position: absolute;
  left: 400px;
  top: 0;
  z-index: 1;
}

.now-marker-text {
  background-color: rgba(255,0,0,0.5);
  position: relative;
  top: 60px;
  width: fit-content;
  padding: 3px 10px;
  color: white;
  font-size: 12px;
}
</style>

<style lang="scss">
$ganttColor: rgba(0,0,0,0.3);
$innerLines: rgba(200,200,200,0.5);

.vertical-line {
  min-width: 1px;
  max-width: 1px;
  background-color: $innerLines;
  height: 100%;
  position: absolute
}

.left-resizer {
  height: calc(100% - 60px);
  width: 6px;
  cursor: col-resize;
  position: absolute;
  left: calc(100% - 3px);
  z-index: 10;
}

.row-content {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-right: 1px solid $innerLines;
  height: 100%;
}

.today-row-date {
  background-color: rgba(0, 255, 255, 0.3);
}

.task-row {
  height: 25px;
  // background-color: rgba(0,0,0,0.5);
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 1px solid $innerLines;
  width: 100%;
}

.task-row-hover {
  background-color: rgba(255,255,0,0.5) !important;
}

.gantt-task-block {
  position: absolute;
  height: 20px;
  background-color: rgb(255,225,225);
  border: 1px solid $ganttColor;
  cursor: pointer;
  min-width: 5px;
  // overflow: hidden;
}

.left-column-text {
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 11px;
  padding: 5px;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 50%;
  flex-grow: 1;
}

.task-left-text, .task-right-text {
  position: relative;
  display: flex;
  align-items: center;
  height: 18px;
  white-space: nowrap;
  pointer-events: none;
}

.task-left-text {
  right: calc(100% + 3px);
  top: 0px;
  text-align: right;
  justify-content: flex-end;
  align-items: flex-end;
}

.task-right-text {
  left: calc(100% + 3px);
  top: -18px;
  text-align: left;
  justify-content: flex-start;
  width: fit-content;
  align-items: flex-start;
}

.task-progress {
  position: relative;
  left: 0;
  top: -36px;
  height: 18px;
  background-color: red;
}

.task-inner-text {
  width: 100%;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  top: -54px;
  height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 11px;
}

.dot {
  background-color: red;
  border-radius: 100%;
  height: 10px;
  width: 10px;
  position: absolute;
  z-index: 99;
}

.gantt-hover-tooltip {
  display: none;
  position: fixed;
  z-index: 9999;
  background: rgba(50, 50, 50, 0.95);
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 11px;
  pointer-events: none;
  min-width: 180px;
  max-width: 280px;
}
.gantt-hover-tooltip .tt-title {
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 6px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gantt-hover-tooltip .tt-row {
  display: flex;
  gap: 4px;
  color: #cccccc;
  margin-bottom: 3px;
  font-size: 11px;
}
.gantt-hover-tooltip .tt-row span:first-child {
  white-space: nowrap;
}
</style>